import DealStatus from './DealStatus';

export default DealStatus;
